<template>
  <div>
    <div>
      <h4 class="title-color">Update Email</h4>
      <div id="input-container" style="width: 70%">
        <ejs-textbox
          id="textbox"
          floatLabelType="Always"
          v-model="userEmail"
          placeholder="Email"
          :readonly="true"
        ></ejs-textbox>
      </div>
    </div>
    <div v-if="!isOwner">
      <div>
        <div id="input-container" style="width: 70%">
          <scc-input-validator
            :rules="[requiredRule, emailRule]"
            :value="this.newUserName"
            @validate="(v) => (this.isEmailValid = v)"
          >
            <ejs-textbox
              floatLabelType="Always"
              v-model="newUserName"
              placeholder="New Email"
            ></ejs-textbox>
          </scc-input-validator>
        </div>
      </div>
      <div class="align-center-bottom">
        <!-- <ejs-button v-on:click.native="onCancelButtonClick"
                    cssClass="e-danger margin-button">Cancel</ejs-button> -->
        <ejs-button
          type="button"
          cssClass="e-info margin-button"
          v-on:click.native="onSubmitButtonClick"
          >Update</ejs-button
        >
      </div>
    </div>
    <div v-else>
      <span
        style="
          font-size: 12px;
          font-weight: 500;
          color: red;
          font-style: italic;
        "
      >
        You are currently listed as a Site Owner. Please contact ASCA at
        1-888-413-0099 to update our email address.
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { emailRule, requiredRule } from '@/shared/constants';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';
import { getContactType } from '../../auth/services/tms-api';
import { CONFIRM_UPDATE_USER_EMAIL } from '../../auth/store';

Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);

export default {
  name: 'UpdateEmail',
  components: {
    SccInputValidator,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  mounted() {
    // this.isOwner = this.$store.getters.loggedUser.isOwner;
    this.loggedUserId = this.$store.getters.loggedUser
      ? this.$store.getters.loggedUser.id
      : '';
    this.checkSiteOwner();
  },
  computed: {
    isLogedUserAdmin() {
      return this.isLogedUserInRole("admin") || this.isLogedUserInRole("superadmin");
    },
    userEmail: {
      get() {
        return this.userProfilesData ? this.userProfilesData.userName : '';
      },
      set(val) {
        return val;
      },
    },
  },
  data() {
    return {
      loggedUserId: null,
      isOwner: false,
      email: null,
      userId: null,
      requiredRule,
      emailRule,
      isEmailValid: false,
      newUserName: null,
    };
  },
  watch: {},
  methods: {
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    isLogedUserInRole(roleName) {
      let roleIndex = -1;
      const logedUser = this.$store.getters.loggedUser;
      if (logedUser && logedUser.roles) {
        roleIndex = logedUser.roles.findIndex((r) => r.roleName.toLowerCase() === roleName);
      }
      return roleIndex >= 0;
    },
    async checkSiteOwner() {
      const SITE_OWNER = 'Site Owner';
      this.userId = this.userProfileId;
      const respContactType = await getContactType(this.userId);
      if (respContactType.data !== null && respContactType.data.length > 0) {
        this.isOwner = !!respContactType.data.find(
          (r) => r.contactType === SITE_OWNER,
        );
      }
    },
    validateForm() {
      if (this.isEmailValid) {
        return true;
      }

      this.newUserName = this.newUserName === null ? '' : this.newUserName;
      this.notify('Error', 'Please enter required field<br>New Email');
      return false;
    },
    async onSubmitButtonClick() {
      try {
        // this.$parent.$parent.notificationToasts.length = 0;
        if (this.isEmailValid) {
          this.userId = this.userProfileId; // this.$store.getters.loggedUser.id;
          const rootURL = window.location.host;
          const { userId, newUserName } = this;
          let isUpdateSuccess = false;
          isUpdateSuccess = !!(await this.$store.dispatch(
            CONFIRM_UPDATE_USER_EMAIL,
            { userId, newUserName, rootURL },
          ));
          if (isUpdateSuccess) {
            if (this.loggedUserId === this.userId) {
              this.notify('Success', 'A active link has been sent to user email account.');
              this.$router.push('/email-sent');
            } else {
              this.notify('Success', 'A active link has been sent to user email account.');
              this.$router.push('/users');
            }
          } else {
            let errorMessage = 'Updating your email process has an error.  Please confirm email does not already exist. Please review email sent to your inbox for details. ';
            if (this.isLogedUserAdmin) {
              errorMessage = "Updating user's email has an error.  Please confirm email does not already exist.";
            }
            this.notify('Error', errorMessage);
          }
        } else {
          this.newUserName = this.newUserName === null ? '' : this.newUserName;
          this.notify('Error', 'Please enter required field<br>New Email');
        }
      } catch (err) {
        this.notify('Error', 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099');
        this.$router.push('/login');
      }
    },
  },
};
</script>
